import React, {useState, useEffect} from 'react'
import ReactMapGL, {Marker, FlyToInterpolator,LinearInterpolator, WebMercatorViewport, Layer} from 'react-map-gl';
// import {easeCubic} from 'd3-ease';
import mapboxgl from 'mapbox-gl';
import markerOne from '../images/Icon-one.svg'
import markerTwo from '../images/Icon-two.svg'
import markerThree from '../images/Icon-three.svg'
import 'mapbox-gl/dist/mapbox-gl.css'

// The following is required to stop "npm build" from transpiling mapbox code.
// notice the exclamation point in the import.
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;




const Map = ({showPage, harvestData, hiveData, packingData}) => {

  const latList = [harvestData.lat, hiveData.lat, packingData.lat]
  const longList = [harvestData.lng, hiveData.lng, packingData.lng]
  const minLat = Math.min(...latList)
  const maxLat = Math.max(...latList)
  const minLong = Math.min(...longList)
  const maxLong = Math.max(...longList)

  const route1Layer = {
    id: 'route',
    type: 'line',
    source: {
      'type': 'geojson',
      'data': {
        'type': 'Feature',
        'properties': {},
        'geometry': {
          'type': 'LineString',
          'coordinates': [
            [
              hiveData.lng,
              hiveData.lat
            ],
            [
              harvestData.lng,
              harvestData.lat
            ]
          ],
        },
      }
    },
    layout: {
      'line-join': 'round',
      'line-cap': 'round'
    },
    paint: {
      'line-color': '#c23f27',
      'line-width': 4,
      'line-opacity': 1
    }

};
const route2Layer = {
    id: 'route2',
    type: 'line',
    source: {
      'type': 'geojson',
      'data': {
        'type': 'Feature',
        'properties': {},
        'geometry': {
          'type': 'LineString',
          'coordinates': [
            
            [
              harvestData.lng,
              harvestData.lat
            ],
            [
              packingData.lng,
              packingData.lat
            ]
          ],
        },
      }
    },
    layout: {
      'line-join': 'round',
      'line-cap': 'round'
    },
    paint: {
      'line-color': '#c23f27',
      'line-width': 4,
      'line-opacity': 1
    }

};

  
  const [viewport, setViewport] = useState({
    width: '100%',
    height: '100%',
    longitude: hiveData.lng,
    latitude: hiveData.lat,
    zoom: 4
  });
  const[test, setTest] = useState(false)
  const[test2, setTest2] = useState(false)

useEffect(()=> {
  if(showPage===1) {
    goTo1()
  }
  if(showPage===2){
    goTo2()
  }
  if(showPage===3){
    goTo3()
  }
  if(showPage===4){
    goTo4()
  }

}, [showPage])


  // Step 1 animation
  const goTo1 = () => {
    const timer = setTimeout(() => {
      setViewport({
          ...viewport,
          longitude: hiveData.lng,
          latitude: hiveData.lat, 
          transitionDuration: 1600,
          transitionInterpolator: new LinearInterpolator(),
          zoom: 10,
  
      //   transitionEasing: easeCubic(0.25)
      });
    }, 1000);
    return () => clearTimeout(timer);
  }

  //Step 2 animation
  const goTo2 = () => {
    setViewport({
      ...viewport,
      longitude: harvestData.lng,
      latitude: harvestData.lat,
      zoom: 10,
      transitionDuration: 800,
      transitionInterpolator: new FlyToInterpolator(),
    //   transitionEasing: easeCubic(0.25)
    });
    setTest(true)
  
  };

  //Step 3 animation
  const goTo3 = () => {
    setViewport({
      ...viewport,
      longitude: packingData.lng,
      latitude: packingData.lat,   
      zoom: 10,
      transitionDuration: 800,
      transitionInterpolator: new FlyToInterpolator(),
    //   transitionEasing: easeCubic(0.25)
    });
    setTest(true)
    setTest2(true)
 
  };

  // Final screen
  const goTo4 = () => {
    const {longitude, latitude, zoom} = new WebMercatorViewport(viewport)
        .fitBounds([[minLong, minLat], [maxLong, maxLat]], {
          padding: 75,
          offset: [0, -100]
        });
    setViewport({
      ...viewport,
      longitude,
      latitude,
      zoom,
      transitionDuration: 1000,
      transitionInterpolator: new FlyToInterpolator(),
      // transitionEasing: d3.easeCubic
    });
    setTest(true)
    setTest2(true)
  };
  return (
    <div>
        <ReactMapGL
        mapboxApiAccessToken={
          "pk.eyJ1IjoiYWdlbnRicmFuZGluZyIsImEiOiJjanlyZDYyenMwOXdxM29taTVnems1enQ3In0.b6-a6FjoAmqH24hBllOC9A"
        }
        {...viewport}
         mapStyle={"mapbox://styles/agentbranding/cku8g5x9t0ljw19s01ig5bhsq"}
        onViewportChange={nextViewport => setViewport(nextViewport)}
        scrollZoom={true}
        dragPan={true}
        dragRotate={false}
        touchZoom={true}
        doubleClickZoom={false}
        
        >
        
            <Marker key="1" longitude={hiveData.lng} offsetLeft={-10} offsetTop={-20} latitude={hiveData.lat}>
                <div className="bb-marker"><img src={markerOne} alt="Hive Marker" /></div>
            </Marker>
            {test && <Marker key="2" longitude={harvestData.lng} offsetLeft={-20} offsetTop={-20} latitude={harvestData.lat}>
                <div className="bb-marker"><img src={markerTwo} alt="Harvest Marker" /></div>
            </Marker>}
                {test2 && <Marker key="3" longitude={packingData.lng} offsetLeft={-10} offsetTop={-20} latitude={packingData.lat}>
                <div className="bb-marker"><img src={markerThree} alt="Packing Marker" /></div>
            </Marker> }
            {test && <Layer {...route1Layer}  />}
            {test2 && <Layer {...route2Layer}  />}
        </ReactMapGL>
    </div>
  );
}

export default Map


